import {NgModule} from "ng-metadata/core";
import {InactiveFacetsMergeLocationFacetsWithinSingleLibraryService} from "./inactiveFacetsMergeLocationFacetsWithinSingleLibrary/inactiveFacetsMergeLocationFacetsWithinSingleLibrary.service";


@NgModule({
    declarations: [
    ],
    providers: [ //place here all transformers that will run on the in active facets list
        InactiveFacetsMergeLocationFacetsWithinSingleLibraryService
    ],
    imports:[

    ]
})
export class InactiveFacetsTransformationsModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/facet/facetsTransformation/inactiveFacetsTransformations/inactiveFacetsTransformations.module.ts